export default __webpack_public_path__ + "static/media/dogTtsIt_It60.971ed7c0.mp3";